import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import DateComp from '../../../../../core/common/dateComponent/DateComp'
import { date } from 'yup'
import dayjs from 'dayjs'

const ElectricRoutesAckg = ({ printOutPdfDetails,onRenderReady,printRef }: any) => {

    const formatDate = (date: Date | string) => {
        return dayjs(date).format("MMM-D-YYYY").toUpperCase();
    };
    const formattedDate = formatDate(new Date());

     useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);
    
    return (
        <div className='row' id='Electric_RoutesAckg' ref={printRef} style={{ pageBreakAfter: "always" }}>
            <div className='col-md-12 px-5'>
                <div className='d-flex justify-content-center align-items-center mt-4'>
                    <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className=""
                        alt="Logo"
                        width={300}
                        height={68}
                    />
                </div>
                <p className='text-center fw-bold'>
                    ELECTRIC REROUTES ACKNOWLEDGEMENT
                </p>
            </div>
            <div className='px-5 mt-3'>
                <div className='d-flex'>
                    <p className='w-20 mb-0'>
                        Client Name:
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.primaryContactLastName} {" "}
                        {printOutPdfDetails?.secondaryContactFirstName ? ' and ' : ''}
                        {printOutPdfDetails?.secondaryContactFirstName} {printOutPdfDetails?.secondaryContactLastName}
                    </p>
                </div>
                <div className='d-flex'>
                    <div>
                        <p className='w-20 mb-0'>
                            Address:
                        </p>
                    </div>
                    <div>
                    <p className='mb-0'>
                            {printOutPdfDetails?.mailingAddressLine1} {" "}
                        </p>
                        <p className='mb-0'>
                            {printOutPdfDetails?.mailingAddressLine2} {" "}
                        </p>
                        <p className='mb-0'>
                            {printOutPdfDetails?.city} {printOutPdfDetails?.state ? ',' : ''} {printOutPdfDetails?.state}  {printOutPdfDetails?.zipCode}
                        </p>
                    </div>
                </div>

                <div className='d-flex'>
                    <p className='w-20 mb-0'>
                        Project Number:
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.projectNumber}
                    </p>
                </div>
                {/* <div className='d-flex'>
                    <p className='w-20 mb-0'>
                        Date:
                    </p>
                    <p className="mb-0">
                       {formattedDate}
                    </p>
                </div> */}
                <div className='mt-3'>
                    <p>
                        Although generally electric kills appear to be obvious items that need to be removed, such as in the case of a breakthrough or wall removal, rerouting of existing electrical is nearly impossible to determine without opening boxes and tracing wires. {" "}
                        <b>
                            Unless specified with an allowance on your plans, reroutes are not included with any item that needs to be killed.  Reroutes are necessary when a switch, outlet or fixture is removed, but the box that it is housed in is still feeding power to other areas of your house. {" "}
                        </b>
                        For example, if a kitchen wall was being removed as part of the project, and an outlet on that wall needed to be killed, it is possible that electric in the dining room will inadvertently, also be killed.  In that case, a reroute of the existing electric to the dining room would be required to get electrical power back to that room.
                        <br />
                        The only way to determine if reroutes are needed before actually doing the electrical work would be to open every box that contains a kill and trace all of the wires within it.  Obviously this is not a practical solution and would probably be more costly than the additional cost of most reroutes.  If it is determined that a reroute will need to take place, your project superintendent will discuss the issue with you along with any additional costs involved.  Although reroutes are typically done on a time and material basis, generally individual reroutes are not extremely costly and will be quoted by the project manager at the time the extent of the work is known.
                        <br />
                        Your contract also includes installation of code compliant hard wired smoke detectors as identified within the plans and contract specifications.  Replacement, adding or upgrading of smoke detectors and/or carbon monoxide detectors in your existing home is not included unless otherwise noted within the signed plans.  Most building departments will require that the existing home meet current life and safety code requirements like hardwired smoke and carbon monoxide detectors in every bedroom and elsewhere as required.  The final requirements for this work shall be assessed in the field by the electrician and the city inspector and additional costs will be incurred by the owner if work over and above the current contract scope is required.  Final costs shall be agreed upon in writing prior to start of said work.
                    </p>
                </div>
                <div className='d-flex justify-content-between align-items-center mt-2'>
                    <p>
                        By Airoom Client X: _______________________

                    </p>
                    <p>
                        Date: {formattedDate}
                    </p>
                </div>
                <div className='d-flex justify-content-between align-items-center mt-3'>
                    <p>
                        By Airoom Client X: _______________________

                    </p>
                    <p>
                        Date: {formattedDate}
                    </p>
                </div>
                <div className='text-center mt-5'>
                    <p className='mb-0'>
                        <b>
                            CORPORATE OFFICES AND DESIGN CENTER {" "}
                        </b>
                        6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                    </p>
                    <p>
                        <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                    </p>
                </div>
            </div>

        </div>
    )
}

export default ElectricRoutesAckg
